import { type ComponentProps } from 'react';

const FlagFR = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <rect width="24" height="18" rx="2" fill="white" />
    <rect width="8" height="18" fill="#002395" />
    <rect x="16" width="8" height="18" fill="#ED2939" />
  </svg>
);

export default FlagFR;
